import { render, staticRenderFns } from "./OutstandingArtworks.vue?vue&type=template&id=165c134b&scoped=true"
import script from "./OutstandingArtworks.vue?vue&type=script&lang=js"
export * from "./OutstandingArtworks.vue?vue&type=script&lang=js"
import style0 from "./OutstandingArtworks.vue?vue&type=style&index=0&id=165c134b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c134b",
  null
  
)

export default component.exports